import { createContext } from 'react';

export interface GeolocationContextProps {
  coordinates: { latitude: number; longitude: number } | null;
  isLoading: boolean;
}

export const GeolocationContext = createContext<GeolocationContextProps>(
  {} as GeolocationContextProps
);
